import React, { useEffect, useState } from 'react';
import { Table, Typography, message } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useLocation } from 'react-router-dom';
import { getDetailedEstReport } from '@app/api/reports.api';
import dayjs from 'dayjs';

const { Title } = Typography;

interface DetailedEstRegsReportProps {
  location_id: number;
  location_name: string;
  filters?: any;
}

interface DetailedReportRow {
  code: string;
  pr_type: string;
  date: string;
  expires_at: string;
  status: string;
}

export const DetailedEstRegsReport: React.FC<DetailedEstRegsReportProps> = ({
  location_id,
  location_name,
  filters,
}) => {
  const [data, setData] = useState<DetailedReportRow[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDetails = async () => {
      setLoading(true);
      try {
        const response: { report: DetailedReportRow[] } = await getDetailedEstReport({
          ...filters,
          pr_location_id: location_id,
        });
        setData(Array.isArray(response.report) ? response.report : []);
      } catch (err) {
        message.error('Failed to fetch detailed report data.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [location_id, filters]);

  const columns: ColumnsType<DetailedReportRow> = [
    { title: 'Code', dataIndex: 'code', key: 'code' },
    { title: 'PR Type', dataIndex: 'pr_type', key: 'pr_type' },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date: string) => (date ? dayjs(date).format('YYYY-MM-DD') : '-'),
    },
    {
      title: 'Expires at',
      dataIndex: 'expires_at',
      key: 'expires_at',
      render: (date: string) => (date ? dayjs(date).format('YYYY-MM-DD') : '-'),
    },
    { title: 'Status', dataIndex: 'status', key: 'status' },
  ];

  return (
    <div>
      <Title level={4}>All registrations of {location_name} farm/establishment</Title>
      <Table columns={columns} dataSource={data} rowKey="code" pagination={false} loading={loading} />
    </div>
  );
};
